import {Fragment} from "react";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import {Box} from "@mui/system";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function SignupButton({label, action, disabled, isLoading}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return(
        <Box width={{xs: '100%', sm: '100%', md: '160px', lg: '160px', }}>
            <Button sx={styles.signupButton}
                    type="submit"
                    onClick={action}
                    disabled={disabled}
                    variant="contained"
                    disableElevation
                    endIcon={ isLoading ?
                        <CircularProgress size={25} sx={styles.progress}/> :
                        ( isMobile ? <ArrowForwardIcon/> : <Fragment/>) }>
                {label}
            </Button>
        </Box>
    )
}

const styles = {
    signupButton: {
        width: '100%',
        fontSize: '18px',
        padding: '10px 0',
        color: '#0f0a06',
        fontFamily: 'FustatSemiBold',
        textTransform: 'capitalize',
        borderRadius: '50px',
        backgroundColor: '#74c4ec',
        ':hover': {
            backgroundColor: '#54b0e6',
            color: '#0f0a06',
        },
        ':disabled': {
            color: '#6c6c6c',
            backgroundColor: '#89cdef'
        }
    },
    progress: {
        color: '#0f0a06',
        marginLeft: '10px'
    }
};